// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-container {
  position: fixed;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;

  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}

.notification {
  background-color: #333;
  color: #fff;
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

  font-weight: 500;

  animation: dropIn 0.3s ease, fadeOut 0.3s ease 2s forwards;
}

/* types */
.notification.success { background-color: #4caf50; }
.notification.error { background-color: #f44336; }
.notification.info { background-color: #2196f3; }

/* TOP → DOWN animation */
@keyframes dropIn {
  from {
    transform: translateY(-10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes fadeOut {
  to {
    opacity: 0;
    transform: translateY(-20px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Notification/notification.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;;EAEb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;;EAExC,gBAAgB;;EAEhB,0DAA0D;AAC5D;;AAEA,UAAU;AACV,wBAAwB,yBAAyB,EAAE;AACnD,sBAAsB,yBAAyB,EAAE;AACjD,qBAAqB,yBAAyB,EAAE;;AAEhD,yBAAyB;AACzB;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;AACF","sourcesContent":[".notification-container {\n  position: fixed;\n  top: 60px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 9999;\n\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: center;\n}\n\n.notification {\n  background-color: #333;\n  color: #fff;\n  padding: 12px 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n\n  font-weight: 500;\n\n  animation: dropIn 0.3s ease, fadeOut 0.3s ease 2s forwards;\n}\n\n/* types */\n.notification.success { background-color: #4caf50; }\n.notification.error { background-color: #f44336; }\n.notification.info { background-color: #2196f3; }\n\n/* TOP → DOWN animation */\n@keyframes dropIn {\n  from {\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOut {\n  to {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
